<template>
<div>
	<div class="front-box animate__backInUp">
		<div class="overflow-hidden">
			<FrontLogo/>
			<div class="body position-relative" :class="{'show-from-right': !showRecoverPassword, 'd-none': showRecoverPassword}">
				<form v-on:submit.prevent="loginUser">
					<ValidationObserver ref="formLogin">
						<ValidationProvider :rules="rules.username" name="vpUsername" v-slot="{ valid, validated }">
							<div class="input-group mb-3" :class="{'error-asterisk': !valid && validated}">
								<div class="input-group-prepend">
									<span class="input-group-text">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
									</span>
								</div>
								<input type="text" class="form-control" v-model="user.Username" @keyup="(event)=>showAlertKey(event)" :placeholder="$t('insert_user')" :readonly="showAuthenticator">
							</div>
						</ValidationProvider>
						<ValidationProvider :rules="rules.password" name="vpPassword" v-slot="{ valid, validated }">
							<div class="input-group mb-3" :class="{'error-asterisk': !valid && validated}">
								<div class="input-group-prepend">
									<span class="input-group-text">
										<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
									</span>
								</div>
								<input :type="type" class="form-control" v-model="user.Password" @keyup="(event)=>showAlertKey(event)" :placeholder="$t('password')" :readonly="showAuthenticator">
								<a href="#" class="show-pass border-0 bg-transparent" @click.prevent="showPassword">
									<svg width="24" height="24" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" focusable="false">
										<path opacity=".3" d="M12 6a9.77 9.77 0 00-8.82 5.5C4.83 14.87 8.21 17 12 17s7.17-2.13 8.82-5.5A9.77 9.77 0 0012 6zm0 10c-2.48 0-4.5-2.02-4.5-4.5S9.52 7 12 7s4.5 2.02 4.5 4.5S14.48 16 12 16z"></path>
										<path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 13a9.77 9.77 0 01-8.82-5.5C4.83 8.13 8.21 6 12 6s7.17 2.13 8.82 5.5A9.77 9.77 0 0112 17zm0-10c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"></path>
										<line v-show="type == 'text'" x1="3" y1="3" x2="21" y2="21" />
									</svg>
								</a>
							</div>
						</ValidationProvider>
						<div class="form-group" :class="{'show-from-right': showAuthenticator, 'd-none': !showAuthenticator}">
							<input type="text" class="form-control" v-model="user.Code" placeholder="Codigo authenticator">
						</div>
					</ValidationObserver>
					<mmButton :click="loginUser" :text="$t('login')" classe="btn btn-primary btn-block font-16" ></mmButton>
					<a href="#" v-if="this.$Params.recover!='0'" @click.prevent="showRecoverPassword=true; $emit('hideMessage')">{{ $t('forgot_password') }}</a>
				</form>
			</div>
			<div class="body position-relative" :class="{'animate show-from-right': showRecoverPassword, 'd-none': !showRecoverPassword}">
				<LoginRecover />
				<a href="#" @click.prevent="showRecoverPassword=false; $emit('hideMessage')"><i class="ms-Icon ms-Icon--Back pr-1 align-middle"></i>{{ $t('back') }}</a>
			</div>			
			<div class="signin_with pb-2 px-3 clearfix">
				<a href="#" @click.prevent="information" class="float-left"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg><span class="pl-1">{{ $t('information') }}</span></a>
				<!--<a href="#" class="float-right d-none" data-toggle="modal"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg><span class="pl-1">{{ $t('contact') }}</span></a>-->
			</div>
		</div>
	</div>

	<mmModal ref="modalInfo" :title="$t('information')" textClose="Tancar">
		<div class="d-block text-center">
			<span v-html="txtInformation.textoBloque1"></span>
				<br><br>
			<span v-html="txtInformation.textoBloque2"></span>
				<br><br>
			<span v-html="txtInformation.textoBloque3"></span>
		</div>
	</mmModal>
</div>
</template>

<script>
	import { textsService } from '@/api/texts';
	import LoginRecover from '@/views/login/LogginRecover.vue';
	import { userService } from '@/api/user';
	import mmButton from '@mysummar/summar-vue/src/components/mmButton.vue'
	import mmModal from '@mysummar/summar-vue/src/components/mmModal.vue'
	import FrontLogo from '@/views/layout/Front-logo.vue';
	import { ValidationObserver, ValidationProvider } from "vee-validate";
    import { rules } from "@/_helpers/validations/validate-login";
	import { notification } from '@/_utils/notification';
	import Cookies from 'js-cookie';

	export default {
	name: 'Loggin',
	data() {
			return {
				rules,
				type: 'password',
				txtInformation : '',
				showAlert: false,
				typeAlert: '',
				alertMessage: '',
				user: {	Username: '',
						Password: '',
						Code: '',
						Fingerprint: ''},
				keepPassword: false,
				showRecoverPassword: false,
				showAuthenticator: false,
				logoImage: `${this.$Params.urlImages}logo`
			}
	},
	components: {
			mmButton,
			LoginRecover,
			mmModal,
			FrontLogo,
			ValidationObserver,
            ValidationProvider
	},
	created() {
		
		if(this.$Params['type'] && this.$Params.type=='Error')
			this.$emit('updateMessage',this.$Params.message, 'danger');					
		
		if (this.$route.query.f){		
			//notification.warning(this.$i18n.t('messages.password_expiration_days', {d: 2}));	
			this.validateFingerprint(this.$route.query.f);
		}
	},
	methods: {
			showAlertKey(event) {
				if (event.keyCode !== 13) this.$emit('hideMessage');
			},
			showPassword() {
				this.type = this.type === 'password' ? 'text' : 'password';
			},
			async information() {

				this.txtInformation = await textsService.information();
				this.$refs.modalInfo.show();
			},
			async validateFingerprint(fingerprint){
				let respuesta = await userService.validateFingerprint(fingerprint);
				
				if(respuesta.valid) 
					this.$emit('updateMessage', this.$i18n.t('messages.fingerprint_verificated'), 'success');				
				else{					
					this.$emit('updateMessage', respuesta.message, 'danger');
				}
			},
			async loginUser() {
				
				let valid = await this.$refs.formLogin.validate();
                   
				if (valid) {									
					let respuesta = await userService.login(this.user, this.keepPassword);
					
					this.$Params.isadmin = respuesta.isadmin;
					this.$Params.need_change_password = respuesta.changePassword;					
					
					Cookies.set("needChangePassword", respuesta.changePassword);

					if(respuesta.valid) {
						if(respuesta.changePassword) this.$router.push('/change_password');
						else this.$router.push(respuesta.isadmin==1 ? '/syslg' : '/home');

						if (respuesta.expirationDays > 0) {
							notification.warning(this.$i18n.t('messages.password_expiration_days', {d: respuesta.expirationDays}));
						}
						if (respuesta.fingerprintWarning){
							notification.warning(this.$i18n.t('messages.fingerprint_warning'));
						}
					}  else {
						if(respuesta.message == 'fingerprint_created') {
							this.$emit('updateMessage', this.$i18n.t('messages.' + respuesta.message), 'warning');
							return;
						}

						if(respuesta.message == 'requires_authenticator') {
							this.showAuthenticator = true;
							return;
						} 
											
						this.$emit('updateMessage',this.$i18n.t('messages.' + respuesta.message), 'danger');
					}
				}
			}
		}
	}
</script>

<style>
	.login-alert {
		font-size: 13px;
		z-index: 1;
		animation-duration: 1s;
		animation-fill-mode: both;
		animation-name: shake;
	}
	.login-alert .ms-Icon {
		font-size: 24px;
	}
	@media only screen and (max-width: 767.9px) {
		.login-alert {
			position: absolute;
			top: 5px;
		}
	}
	@media only screen and (min-width: 768px) {
		
		.front-box, .login-alert {
			width: 380px;
		}
		.front-box > div {
			border-radius: 10px;
			background: #f5f5f5;
			border: 5px solid #fff;
			box-shadow: 0 0 16px rgba(41,42,51,.06), 0 6px 20px rgba(41,42,51,.02);
		}
	}
	.front-box .body {
		padding: 20px;
	}
	.front-box .form-control {
		font-size: initial;
	}
	.front-box .show-pass {
		position: absolute;
		right: 3px;
		top: 6px;
		opacity: .7;
		z-index: 10;
	}
	.front-box .error-asterisk .show-pass {
		right: 18px;
	}
	.front-box .show-pass:hover {
		opacity: 1;
	}
	.front-box .show-pass path { fill:#97a6ba; }
	.front-box .show-pass line { stroke:#97a6ba; stroke-width: 3px; }
	.front-box .btn-login {
		font-size: 16px;
	}
	.show-from-right {
		animation:show-from-right .25s cubic-bezier(.5,0,.5,1) both;
		transition-property: left
	}
	@keyframes show-from-right{
		from{
			left:-200px;
			opacity:0
		}
		to{
			left:0;
			opacity:1
		}
	}
	@keyframes slide-out-left{
		from{
			left:0;
			opacity:1
		}
		to{
			left:-200px;
			opacity:0
		}
	}

	.animate__backInUp {
		animation: backInUp 1s both;
	}
@keyframes backInUp{
0% {
    transform: translateY(1200px) scale(.7);
    opacity: .7;
}

80% {
    -webkit-transform: translateY(0) scale(.7);
    transform: translateY(0) scale(.7);
    opacity: .7;
}
100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
}
}

@keyframes shake {
	0%, 100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
}

10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
}
20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
}
}
</style>
